var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, "before-close": _vm.cancelRename },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "h5",
        {
          staticClass: "el-dialog__title",
          attrs: { slot: "title" },
          slot: "title"
        },
        [_vm._v("Embed  ")]
      ),
      _vm._v(" "),
      !_vm.mode
        ? _c(
            "div",
            { staticClass: "mode-switch" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.mode === "select" ? "primary" : "default"
                  },
                  on: {
                    click: function($event) {
                      _vm.mode = "select"
                    }
                  }
                },
                [_vm._v("\n        Select Existing Page\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "create-page",
                  attrs: {
                    type: _vm.mode === "create" ? "primary" : "default"
                  },
                  on: {
                    click: function($event) {
                      _vm.mode = "create"
                    }
                  }
                },
                [_vm._v("\n        Create New Page\n      ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "select"
        ? _c(
            "div",
            { staticClass: "select-wrapper" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Choose a page" },
                  on: { change: _vm.embedForm },
                  model: {
                    value: _vm.pageId,
                    callback: function($$v) {
                      _vm.pageId = $$v
                    },
                    expression: "pageId"
                  }
                },
                _vm._l(_vm.pages, function(page, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: page, value: index }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "back-btn",
                  attrs: { type: "warning" },
                  on: { click: _vm.resetMode }
                },
                [_vm._v("Back")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "create"
        ? _c(
            "div",
            { staticClass: "create-wrapper" },
            [
              _c("el-input", {
                attrs: { placeholder: "Enter new page title" },
                model: {
                  value: _vm.newPageTitle,
                  callback: function($$v) {
                    _vm.newPageTitle = $$v
                  },
                  expression: "newPageTitle"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-group" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.createPage }
                    },
                    [_vm._v("Create & Embed")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "back-btn",
                      attrs: { type: "warning" },
                      on: { click: _vm.resetMode }
                    },
                    [_vm._v("Back")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticClass: "el-button--soft",
              attrs: { type: "info" },
              on: { click: _vm.cancelRename }
            },
            [_vm._v("Cancel")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }